/**
 * Singleton socket client. Uses sails.io.js so we can call Sails virtual HTTP routes
 * over the WebSocket transport (e.g. `socket.get('/:companyId/sockets/subscribe', cb)`).
 *
 * Auth: cookies are sent automatically with the same session as REST.
 *
 * Reconnection is enabled by default (socket.io-client behaviour).
 */
// @ts-expect-error — sails.io.js has no shipped types
import sailsIO from "sails.io.js";
// @ts-expect-error — socket.io-client@2.x has no shipped types
import socketIOClient from "socket.io-client";
import { API_URL } from "../constants";

interface SailsSocket {
  on: (event: string, handler: (...args: unknown[]) => void) => void;
  off: (event: string, handler?: (...args: unknown[]) => void) => void;
  get: (
    url: string,
    cb: (data: unknown, jwres: { statusCode: number; body?: unknown }) => void
  ) => void;
  post: (
    url: string,
    body: unknown,
    cb: (data: unknown, jwres: { statusCode: number; body?: unknown }) => void
  ) => void;
  isConnected: () => boolean;
}

const io = (sailsIO as any)(socketIOClient);

io.sails.url = API_URL;
io.sails.autoConnect = true;
io.sails.reconnection = true;
io.sails.transports = ["websocket"];
// Skip the GET /__getcookie pre-flight — REST has already set the session cookie,
// and the route is gated by isLoggedIn (returns 403 for an anonymous request).
io.sails.useCORSRouteToGetCookie = false;

export const socket: SailsSocket = io.socket;

/** Promise wrapper around `socket.get(...)`. */
export function socketGet<T = unknown>(url: string): Promise<T> {
  return new Promise((resolve, reject) => {
    socket.get(url, (data, jwres) => {
      if (jwres.statusCode >= 200 && jwres.statusCode < 300) {
        resolve(data as T);
      } else {
        reject(jwres);
      }
    });
  });
}
